import React from 'react'
import { observer } from 'mobx-react-lite'
import { UpdateReportAdTypes } from '../../util/contstants'
import { SmartBidSettingBadge } from '../SmartBidSettingsBadge'
import { CampaignName } from './CampaignName'
import { CampaignOrAdGroupBadges } from './CampaignOrAdGroupBadges'

export const RenderCampaignName = observer((props: any) => {
    const { data, screenshotMode, mutateItems, fill, recipe_version } = props

    let smartBids = true
    if (recipe_version === 2) {
        smartBids = false
    }

    return (
        <div className="flex min-w-0 w-full items-center">
            {smartBids && (
                <SmartBidSettingBadge
                    className="mr-3"
                    parent_id={data.campaign_id}
                    parent_type={UpdateReportAdTypes.Campaigns}
                    active={data?.smart_bid_setting?.length ? data.smart_bid_setting[0].id : false}
                    mutateItems={mutateItems}
                    onSave={undefined}
                />
            )}
            <div className="flex h-full min-w-0 flex-1 items-center">
                <CampaignOrAdGroupBadges data={data} />
                <CampaignName
                    showBadge={false}
                    campaign={data}
                    screenshotMode={screenshotMode}
                    fill={fill}
                />
            </div>
        </div>
    )
})
